import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "assets/scss/material-kit-react.scss?v=1.9.0";

// pages for this product
// import Components from "views/Components/Components.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import CustomizedTimeline from 'views/LandingPage/TimeLine.js'
import Progress from 'views/LandingPage/Progress.js'


var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/" exact component={LandingPage} />
      <Route path='/TimeLine' exact component={CustomizedTimeline}/>
      <Route path='/Progress' exact render={Progress}/>
    </Switch>
  </Router>,
  document.getElementById("root")
);
